import axios from 'axios';

const state = {
    orders: [],
    currentOrder: null,
};

const actions = {
    shop_order_list({ commit }, { shopId, params = {} }) {
        return axios.get('shop/' + shopId + '/orders', { params }).then(r => {
            commit("SET_ORDERS", r.data.data.orders); return r;
        });
    },
    shop_order_detail({ commit }, id) {
        return axios.get('shop/order/' + id).then(r => {
            commit("SET_CURRENT_ORDER", r.data.data); return r;
        });
    },
    shop_order_update_status(_, { id, status }) {
        return axios.put('shop/order/' + id + '/status', { status });
    },
    shop_order_mark_paid(_, id) {
        return axios.put('shop/order/' + id + '/mark-paid');
    },
    shop_order_input_resi(_, { id, payload }) {
        return axios.put('shop/order/' + id + '/resi', payload);
    },
    shop_order_cancel(_, { id, reason }) {
        return axios.put('shop/order/' + id + '/cancel', { reason });
    },
    shop_order_refund(_, { id, reason }) {
        return axios.put('shop/order/' + id + '/refund', { reason });
    },
};

const mutations = {
    SET_ORDERS(state, orders) { state.orders = orders; },
    SET_CURRENT_ORDER(state, data) { state.currentOrder = data; },
};

export default { namespaced: true, state, actions, mutations };
